import { signInFormReducer } from '@zocdoc-frontend-common/components-sign-in-form';
import {
    SIGN_IN_REDUCER_KEY,
    LOCATION_REDUCER_KEY,
    USER_REDUCER_KEY,
    userReducer,
    locationReducer,
} from '../redux/reducers';

const reducers = {
    [SIGN_IN_REDUCER_KEY]: signInFormReducer,
    [LOCATION_REDUCER_KEY]: locationReducer,
    [USER_REDUCER_KEY]: userReducer,
};

export default reducers;
